import { OpenAPI } from './generated';
import { resolveApiBaseUrl } from './apiBaseUrl';

const apiBaseUrl = resolveApiBaseUrl(process.env.REACT_APP_API_URL);
const csrfCookieName = process.env.REACT_APP_CSRF_COOKIE_NAME || 'glyder_csrf';
const csrfHeaderName = process.env.REACT_APP_CSRF_HEADER_NAME || 'X-CSRF-Token';

const readCookie = (name) => {
  if (typeof document === 'undefined' || !document.cookie) return null;
  const prefix = `${encodeURIComponent(name)}=`;
  const parts = document.cookie.split(';').map((part) => part.trim());
  for (const part of parts) {
    if (part.startsWith(prefix)) {
      return decodeURIComponent(part.slice(prefix.length));
    }
  }
  return null;
};

OpenAPI.BASE = apiBaseUrl;

// Explicitly configure credential behavior for all API calls.
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.TOKEN = undefined;
OpenAPI.HEADERS = async (options) => {
  const method = String(options?.method || 'GET').toUpperCase();
  if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return {};
  }
  const csrfToken = readCookie(csrfCookieName);
  return csrfToken ? { [csrfHeaderName]: csrfToken } : {};
};
